import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var GET_QUOTE_REQUEST = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getQuoteCount {\n        mpCurrentQuote {\n            quote {\n                items_count\n                items_qty\n            }\n        }\n    }\n"])));